// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"f1204bf4","198":"cf2eeca9","353":"79a11404","787":"0e892a70","850":"46d326bf"}[chunkId] + ".chunk.js";
};